var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-wrapper"},_vm._l((_vm.profList),function(prof,i){return _c('prof-item',{key:i,attrs:{"data":prof}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }